import { BASE_PLAN_SUB_TYPES, planTypes } from '@/common/constants';
import { flowTypes, pageConfig } from '@/common/service/page-config';
import { getPlanTypeByCategory } from '@/common/service/parse';
import { $query } from '@/global-install';
import store from '@/store';
import { plansof } from '@/utils/chain';
import cookie from 'js-cookie'
import _ from "lodash";
import { computedPbxCallingPlans } from '@/common/service/computers/plans/pbx';
import { isEmptyVal } from '@/utils';

export const ZOOM_MEETING_SUB_TYPES = {
  PRO: 'pro',
  PRO25: 'pro25',
  PRO50: 'pro50',
  PRO_FREE_TRIAL: 'pro_freetrial',
  BIZ: 'biz',
  PRO_PLUS: 'zoneproplus',
  BIZ_PLUS: 'bizplus',
  BIZ_INR: 'biz_inr',
  EDUCATION: 'education',
  ENTERPRISE: 'bundle',
  EDU_SITE: 'edu_site',
  ZOOM_ONE_PRO_PLUS: 'zone_proplus',
  ZOOM_ONE_BIZ_PLUS: 'zone_bizplus',
  ZOOM_ONE_ENTERPRISE: 'zone_enterprise',
  ZOOM_ONE_ENTERPRISE_PLUS: 'zone_enterprise_plus',
};

export const getCategoryNameI18nKey = (category) => {
  switch (category) {
    case ZOOM_MEETING_SUB_TYPES.BIZ:
      return 'billing.business';
    case ZOOM_MEETING_SUB_TYPES.PRO:
      return 'billing.pro';
    case ZOOM_MEETING_SUB_TYPES.BIZ_PLUS:
      return 'billing.planform.title.biz_plus';
    case ZOOM_MEETING_SUB_TYPES.PRO_PLUS:
      return 'billing.zone_pro_plus.brief_title';
  }
};

export const getTitleNameI18nKey = (category) => {
  switch (category) {
    case ZOOM_MEETING_SUB_TYPES.BIZ:
      return 'billing.planform.title.zoom_one_biz';
    case ZOOM_MEETING_SUB_TYPES.PRO:
      return 'billing.planform.title.zoom_one_pro';
    case ZOOM_MEETING_SUB_TYPES.BIZ_PLUS:
      return 'billing.planform.title.zoom_one_biz_plus';
    case ZOOM_MEETING_SUB_TYPES.PRO_PLUS:
      return 'billing.zone_pro_plus.title';
  }
};

export const DEFAULT_MEETING_PLAN_CAPACITY = {
  category: 'pro',
  billingCycle: 'annual',
  selectedNumber: 1,
};

export const DEFAULT_MEETING_BIZ_PLAN_CAPACITY = {
  category: 'biz',
  billingCycle: 'annual',
  selectedNumber: 1,
};

export const DEFAULT_SCHEDULER_PLAN_CAPACITY = {
  category: 'zsched',
  billingCycle: 'annual',
  selectedNumber: 1,
};

export const PARENT_TYPES_ZOOM_MEETING_ADDON_FOR = [planTypes.ZOOM_SCHEDULER ,planTypes.ZOOM_WHITEBOARD,planTypes.ZOOM_WHITEBOARD_PLUS,planTypes.ZOOM_ROOMS];
export const PARENT_TYPES_ZOOM_MEETING_ADDON_FOR_STANDALONE = [planTypes.ZOOM_WHITEBOARD, planTypes.ZOOM_WHITEBOARD_PLUS];
export const isZoomMeetingAsAddonCard = () => {
  const { plan = 'pro' , from } = pageConfig;
  if(pageConfig.type === flowTypes.add2cart || pageConfig.type === flowTypes.buyTrial || pageConfig.type === flowTypes.add2trial) return false
  const fromStandAlone = PARENT_TYPES_ZOOM_MEETING_ADDON_FOR_STANDALONE.includes(getPlanTypeByCategory(from))
  return PARENT_TYPES_ZOOM_MEETING_ADDON_FOR.includes(getPlanTypeByCategory(plan)) || fromStandAlone;
}
export const isZoomSchedulerAsAddonCard = () => {
  const { plan = 'pro' , from } = pageConfig;
  const fromStandAlone = PARENT_TYPES_ZOOM_MEETING_ADDON_FOR_STANDALONE.includes(getPlanTypeByCategory(from))
  return (
    pageConfig.type === flowTypes.basic2pro || pageConfig.type === flowTypes.buyNow
  ) && [planTypes.ZOOM_MEETING, planTypes.ZONE_PRO_PLUS].includes(getPlanTypeByCategory(plan)) && !fromStandAlone;
}

// TODO: would be removed after webinar and english region features done.
export const additionalZoomSchedulerAsAddonCardCheck = (getSelectedPlans = []) => {
  const cookieLang = cookie.get('_zm_lang');
  const { from = 'pro', enableSchedulerOnlineBuy = false } = pageConfig;
  const isBizOrBizPlus = plansof(getSelectedPlans).category(BASE_PLAN_SUB_TYPES.BIZ, BASE_PLAN_SUB_TYPES.ZOOM_ONE_BIZ_PLUS).has();
  return isZoomSchedulerAsAddonCard() && !isBizOrBizPlus && (![planTypes.WEBINAR, planTypes.ZOOM_EVENTS].includes(getPlanTypeByCategory(from))/* Don't touch webinar & events */) && cookieLang === 'en-US' && enableSchedulerOnlineBuy/* Currency check */;
}

export const isBizPlusContext = pageConfig?.editConfig?.planType === planTypes.ZOOM_ONE_BUNDLE || getPlanTypeByCategory?.($query?.plan) === planTypes.ZOOM_ONE_BUNDLE;
export const isBizPlusEditContext = (plans) => isBizPlusContext && plansof(plans).type(planTypes.ZOOM_ONE_BUNDLE).has();
export const isBizEditContext = pageConfig.type === flowTypes.edit && pageConfig?.editConfig?.category === BASE_PLAN_SUB_TYPES.BIZ;

export const isProPlusContext = pageConfig?.editConfig?.planType === planTypes.ZONE_PRO_PLUS || getPlanTypeByCategory?.($query?.plan) === planTypes.ZONE_PRO_PLUS;
export const isProPlusEditContext = (plans) => isProPlusContext && plansof(plans).type(planTypes.ZONE_PRO_PLUS).has();

export const isZoneBundleContext = isBizPlusContext || isProPlusContext;

// promotion not include pbx plan, just for zoom one bundle plan
export const onlyPromotionZoneBundleForCampaign = (getSelectedPlans = []) => {
  // from coupon campaign link
  if (isEmptyVal(pageConfig.marketingCoupon)) return;

  const hasZonePlan = _.some(getSelectedPlans, (plan) => [planTypes.ZOOM_ONE_BUNDLE, planTypes.ZONE_PRO_PLUS].includes(plan.type));
  // exist zoom one bundle plan for promotion
  if (!hasZonePlan) return;

  const includePbxCallingPlan = computedPbxCallingPlans(getSelectedPlans).length;
  // not include pbx plan promotion
  return !includePbxCallingPlan;
}

export const isShowRemoveBtn = (planType) => {
  const isMajorPlan = pageConfig?.editConfig?.planType === planType;
  if(isMajorPlan) return false;
  return (pageConfig.type === flowTypes.basic2pro || pageConfig.type === flowTypes.buyNow);
}

export const isShowBizCard = () => {
  const { hasHealthcareBiz, fromCampaignLink, plansofBizBundle, hasDowngradeRequest, migratePlanState } = store.getters;
  const { boughtBizPlan, boughtBizPlusPlan } = plansofBizBundle;
  // check if has_downgrade_request is true, if it is true, that means there has biz plus downgrade to biz job
  const hasDowngradeRequestForBizPlus = boughtBizPlusPlan.find(p => hasDowngradeRequest[p.plan_code]);
  // check if has pending activation/downgrade biz plan
  let hasPendingBizPlan = checkBizPlanIsPending();
  // if is pro plus to biz plus
  const isUpgrade = migratePlanState.is.upgrade;
  // if has biz plan, hide biz card
  return !isUpgrade && !hasPendingBizPlan && !hasDowngradeRequestForBizPlus && !boughtBizPlan.length && !hasHealthcareBiz && !fromCampaignLink;
}

export const getMeetingPlanByCategory = (plans, category = BASE_PLAN_SUB_TYPES.BIZ) => {
  return plansof(plans).type(planTypes.ZOOM_MEETING).category(category).get(0) || {};
}

export const checkBizPlanIsPending = () => {
  // check if has pending activation/downgrade biz plan
  const { basicConfig, planMapFlat } = store.getters;
  const { pendingPlanCodes = [] } = basicConfig;
  const bizPlans = plansof(planMapFlat).type(planTypes.ZOOM_MEETING).category(BASE_PLAN_SUB_TYPES.BIZ).get();
  return !!bizPlans.find(p => pendingPlanCodes.includes(p.plan_code));
}
